import Contents from './Contents';
import Sky from './Sky';
import Stars from './Stars';
import Competition from './Competition';
import Hero from './Hero';
import Spiral from './Spiral';
import QuestionMarks from './QuestionMarks';
import VisibilityGroup from '../common/VisibilityGroup';
import Camera from './Camera';
import Effects from './Effects';

export default function Landscape() {
  return (
    <VisibilityGroup beaker="chapter1">
      <Hero />
      <Contents />
      <Spiral />
      <Competition />
      <QuestionMarks />
    </VisibilityGroup>
  );
};

export const Mount = () => {
  return (
    <>
      <Sky />
      <Stars />
    </>
  );
};

export { Camera, Effects };